//Cards
export const VINCULARCORREO = "vincular correo";
export const VERPLANES = "ver planes";
export const SELECTCONTENT = "select_content"
export const INICIO = "inicio"
export const MODULENAME = 'recuerda que por ser cliente telmex disfrutas claro video sin costo'

// Tipos de usuario, utilizados para identificar el tipo de registro o login
export const EXTERNAL_REGISTER = "EXTERNAL_REGISTER";
export const EXTERNAL_LOGIN = "EXTERNAL_LOGIN";
export const TELMEX_OOH_REGISTER = "TELMEX_OOH_REGISTER";
export const TELMEX_OOH_LOGIN = "TELMEX_OOH_LOGIN";
export const TELMEX_IP_REGISTER = "TELMEX_IP_REGISTER";
export const TELMEX_IP_LOGIN = "TELMEX_IP_LOGIN";


// WEBPACK FOOTER //
// ./src/components/centerNotification/constants.ts